import Navbar from './navbar'
import AnimatedRoutes from './animatedRoutes';
import { BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';


function App() {
  return (
    <div className="App">
      <div className="content">
        <Router>
        <Navbar />
        <AnimatedRoutes/>
        </Router>
      </div>
    </div>
  );
}

export default App;
